import { useEffect, useRef } from 'react'
import { useRouter } from 'next/router'
import useLocale from '../../hooks/useLocale'
import gtmService from '../../services/gtm.service'

const getPageLocation = (path: string) => {
  if (typeof window === 'undefined') return path
  return `${window.location.origin}${path}`
}

export default function AnalyticsEvents() {
  const router = useRouter()
  const { locale } = useLocale()
  const lastTrackedPathRef = useRef('')

  useEffect(() => {
    const trackPageView = (path: string) => {
      if (lastTrackedPathRef.current === path) return

      lastTrackedPathRef.current = path
      gtmService.pageView({
        pagePath: path,
        pageLocation: getPageLocation(path),
        pageTitle: document.title,
        language: locale,
      })
    }

    trackPageView(router.asPath)
    router.events.on('routeChangeComplete', trackPageView)

    return () => {
      router.events.off('routeChangeComplete', trackPageView)
    }
  }, [router.asPath, router.events, locale])

  return null
}
